module.exports = __webpack_public_path__ + "static/img/C01-人大附中深圳学校1.00529f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/C01-人大附中深圳学校1.png
// module id = hsdl
// module chunks = 0